export default __webpack_public_path__ + "static/media/close.d4a76e94.png";